export default __webpack_public_path__ + "static/media/köide-54-55.8d4ceb69.png";